export default __webpack_public_path__ + "media/img-2.937cee56.png";